export default "__VITE_ASSET__B8wajxzK__"